const CornerRadiusValues = Object.freeze({
    '--radius-circle': '50%',
    '--radius-0': '0px',
    '--radius-2': '2px',
    '--radius-4': '4px',
    '--radius-8': '8px',
    '--radius-12': '12px',
    '--radius-16': '16px',
    '--radius-20': '20px',
    '--radius-22': '22px',
    '--radius-24': '24px',
    '--radius-32': '32px',
});
const CornerRadius = {
    circle: 'var(--radius-circle)',
    r0: 'var(--radius-0)',
    r2: 'var(--radius-2)',
    r4: 'var(--radius-4)',
    r8: 'var(--radius-8)',
    r12: 'var(--radius-12)',
    r16: 'var(--radius-16)',
    r20: 'var(--radius-20)',
    r22: 'var(--radius-22)',
    r24: 'var(--radius-24)',
    r32: 'var(--radius-32)',
};

export { CornerRadius, CornerRadiusValues };
